import type { AgentScope, StyleEntitiesQuery } from "src/graphql/types";
import { isStyleVisibleToAgent } from "src/pages/context-hub/styles/types";

type StyleEntityRow = StyleEntitiesQuery["styleEntities"][number];

/** Whether a picker offers the style on these surfaces, before brand filtering; the selected one always stays. */
export function isStyleOffered(
  style: Pick<StyleEntityRow, "id" | "isActive" | "agentScopes">,
  surfaces: readonly AgentScope[],
  selectedStyleId: string | undefined,
): boolean {
  return (
    style.id === selectedStyleId ||
    (style.isActive &&
      surfaces.some((surface) =>
        isStyleVisibleToAgent(style.agentScopes, surface),
      ))
  );
}
